export default {
  processSteps: 'Prozessschritte',
};
